import { Link, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { useMemo } from "react";

import { reportNavLinks } from "../report/helpers/reportHelpers";

const NextPrevLinks = ({ className, nextSection, prevSection }) => {
	const { pathname } = useLocation();
	const nextPrev = useMemo(() => {
		const currentSelection = pathname.split("/").pop();
		if (reportNavLinks[currentSelection]) {
			const keys = Object.keys(reportNavLinks);
			const currentIndex = keys.indexOf(currentSelection);
			const prevKey = currentIndex > 0 ? keys[currentIndex - 1] : null;
			const nextKey = currentIndex < keys.length - 1 ? keys[currentIndex + 1] : null;
			return {
				next: nextKey ? { ...reportNavLinks[nextKey], link: `/report/${nextKey}` } : null,
				prev: prevKey ? { ...reportNavLinks[prevKey], link: `/report/${prevKey}` } : null
			};
		}
		return null;
	}, [nextSection, prevSection]);

	return (
		<div className={`d-flex justify-content-center gap-3 y-3 ${className}`}>
			{prevSection
				? (
					<Button as={Link} to={prevSection.link} variant="secondary">
						&larr; {prevSection.label}
					</Button>
				) : nextPrev?.prev
					? (
						<Button as={Link} to={nextPrev.prev.link} variant="secondary">
							&larr; {nextPrev.prev.label}
						</Button>
					)
					: null}
			{nextSection
				? (
					<Button as={Link} to={nextSection.link} variant="primary">
						{nextSection.label} &rarr;
					</Button>
				) : nextPrev?.next
					? (
						<Button as={Link} to={nextPrev.next.link} variant="primary">
							{nextPrev.next.label} &rarr;
						</Button>
					)
					: null}
		</div>
	);
};

NextPrevLinks.propTypes = {
	className: PropTypes.string,
	nextSection: PropTypes.shape({
		label: PropTypes.string,
		link: PropTypes.string
	}),
	prevSection: PropTypes.shape({
		label: PropTypes.string,
		link: PropTypes.string
	})
};

NextPrevLinks.defaultProps = {
	className: "",
	nextSection: null,
	prevSection: null
};

export default NextPrevLinks;